import { changeValueWithOperand } from '../../../../widgets/search-form/utils/passengers';
import { generateSelection, isValidSelection } from './Passengers';

export const onInfantsCounterClick =
  (
    operand: 'plus' | 'minus',
    adults: number,
    children: number,
    infants: number,
    childrenAges: number[],
    infantsAges: number[],
    onChange: (selection: {
      adults: number;
      children: number;
      infants: number;
      childrenAges: number[];
      infantsAges: number[];
    }) => void,
  ) =>
  () => {
    const newInfants: number = changeValueWithOperand(infants, operand);
    if (isValidSelection(adults, children, newInfants)) {
      onChange(generateSelection(adults, children, newInfants, childrenAges, infantsAges));
    }
  };
